import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-60">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-61">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[150%] bg-teal/10 rounded-full blur-3xl transform rotate-12" data-id="element-62"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[150%] bg-white/5 rounded-full blur-3xl transform -rotate-12" data-id="element-63"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-64">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-bold font-heading text-white mb-6 leading-tight" data-id="element-65">
          Ready to Grow Your <br className="hidden sm:block" data-id="element-66" />
          Ecommerce Brand?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-teal-light mb-10 max-w-2xl mx-auto" data-id="element-67">
          Book a free 15-minute strategy call. We'll review your store, discuss
          your goals, and show you exactly how we can help — with real examples
          from brands like yours.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-68">
          <a href="https://calendly.com/fahad-3techno/strategy-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy bg-white rounded-xl hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 mb-4 group" data-id="element-69">
            Book Your Free Strategy Call
            <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-70" />
          </a>

          <p className="text-sm text-gray-400 font-medium" data-id="element-71">
            No commitment. No sales pitch. Just a conversation.
          </p>
        </motion.div>
      </div>
    </section>;
}